// extracted by css-extract-rspack-plugin
export default {"blockQualityNet":"S1eJpZkrJCkt5ZC3","clickable":"IQiK9Mo62kwRKGaj"};